module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }